/**
 * 修正行高
 * 根据元素的高度，定于不同的样式
 */
"use strict";
angular.module("revisedLineHeightModule", []).
directive("revisedLineHeight", ["$timeout", "$compile", function($timeout, $compile) {
    return {
        restrict: "A",
        replace: false,
        scope: true,
        link: function(scope, $element, $attrs) {
            init();
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                scope.status = {
                    showButton: false,
                    hideP: true
                };
                var $buttons = $compile('<span ng-if="status.showButton&&status.hideP" class="unfold" ng-click="fold()">展开全文<span class="iconfont icon-xiangxiajiantou"></span></span>' +
                    '<span ng-if="status.showButton&&!status.hideP" class="packup" ng-click="unFold()">收起<span class="iconfont icon-xiangshang_jiantou"></span></span><input class="hideInput"/>')(scope);
                $timeout(function() {
                    $buttons.insertAfter($element);
                    var height = $element[0].offsetHeight;
                    if (height > 112) {
                        $element.addClass("hide-p");
                        scope.status.showButton = true;
                    }
                });
            }
            /**
             * [fold description] 展开
             * @return {[type]} [description]
             */
            scope.fold = function(){
            	scope.status.hideP = false;
            	$element.removeClass("hide-p");
            };
            /**
             * [unFold description] 收起
             * @return {[type]} [description]
             */
            scope.unFold = function(){
            	scope.status.hideP = true;
            	$element.addClass("hide-p");
            	$element.next().next()[0].focus();
            };
        }
    };
}]);